<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="elevation-10">
          <v-card-actions>
            <v-row>
              <v-col
                cols="4"
              >
                <v-text-field
                  v-model="search"
                  placeholder="Key in course category name here"
                  append-icon="search"
                  label="Search course category"
                  hide-no-data
                  hide-selected
                  clearable 
                />
              </v-col>
              <v-col
                cols="4"
              >
                <v-select
                  v-model="statusFilter"
                  :items="items"
                  item-text="state"
                  item-value="value"
                  label="Course Category's Status"
                  placeholder="Active / Deleted"
                />
              </v-col>
              <v-col
                cols="2"
                offset-md="2"
              >
                <setup-training-course-categories-dialog-create
                  @created="loadCourseCategories"
                />
              </v-col>
            </v-row>
          </v-card-actions>
          
          <v-data-table
            :headers="headers"
            :items="filteredCourseCategories"
            :loading="tableLoading"
            :search="search"
          >
            <template v-slot:item.name="{ item }">
              <div>
                <span>
                  {{ item.name }}
                </span>
              </div>
            </template>
            <template v-slot:item.action="{ item }">
              <span v-if="statusFilter">
                <setup-training-course-categories-dialog-edit
                  :course-category="item"
                  @updated="loadData"
                />
                <span class="mx-1" />
                <setup-training-course-categories-dialog-delete
                  :course-category="item"
                  @deleted="loadData"
                />
              </span>
              <span v-else>
                <setup-training-course-categories-dialog-restore
                  :course-category="item"
                  @restored="loadData"
                />
              </span>
            </template>
          </v-data-table>
        </v-card> 
      </v-col>
    </v-row>    
  </v-container>
</template>

<script>
  export default {
    components: {
      SetupTrainingCourseCategoriesDialogCreate: () => import('@/components/setup/training/course-categories/DialogCreate'),
      SetupTrainingCourseCategoriesDialogEdit: () => import('@/components/setup/training/course-categories/DialogEdit'),
      SetupTrainingCourseCategoriesDialogDelete: () => import('@/components/setup/training/course-categories/DialogDelete'),
      SetupTrainingCourseCategoriesDialogRestore: () => import('@/components/setup/training/course-categories/DialogRestore'),
    },
    metaInfo () {
      return {
        title: 'Course Categories',
      }
    },
    data () {
      return {
        courseCategories: [],
        trashedCourseCategories: [],
        headers: [
          {
            text: 'Course Categories',
            align: 'left',
            value: 'name',
          },
          {
            text: 'Actions',
            sortable: false,
            value: 'action',
          },
        ],

        search: '',
        statusFilter: { state: 'Active', value: true },
        items: [
          { state: 'Active', value: true },
          { state: 'Deleted', value: false },
        ],
        tableLoading: true,
      }
    },
    computed: {
      filteredCourseCategories () {
        return this.statusFilter ? this.courseCategories : this.trashedCourseCategories
      },
    },
    created () {
      this.loadData()
    },
    methods: {
      loadData () {
        this.loadCourseCategories()
        this.loadTrashedCourseCategories()
      },
      loadCourseCategories () {
        this.$api.courseCategories().list()
          .then(response => {
            this.courseCategories = response.data
            this.tableLoading = false
          })
      },
      loadTrashedCourseCategories () {
        this.$api.courseCategories().listTrashed()
          .then(response => {
            this.trashedCourseCategories = response.data
          })
      },
    },
  }
</script>

<style lang='css' scoped>
</style>
